{
  "title": "Moderation",
  "description": "Reported messages, and what was done about them.",
  "loading": "Loading…",
  "empty": "No reports in this view.",
  "filters": {
    "status": "Status",
    "reason": "Reason",
    "all": "All"
  },
  "status": {
    "open": "Open",
    "reviewed": "Reviewed",
    "dismissed": "Dismissed"
  },
  "reason": {
    "abuse": "Bullying or abuse",
    "inappropriate": "Inappropriate content",
    "spam": "Spam",
    "other": "Other"
  },
  "row": {
    "reportedBy": "Reported by {{name}}",
    "author": "Written by {{name}}",
    "thread": "Conversation",
    "openThread": "Open conversation",
    "details": "Reporter's note",
    "removedMessage": "This message has been removed.",
    "reviewedBy": "Reviewed by {{name}}",
    "resolutionNote": "Reviewer's note"
  },
  "actions": {
    "dismiss": "Dismiss",
    "remove_message": "Remove message",
    "mute_participant": "Mute author"
  },
  "confirm": {
    "title": "Review this report",
    "dismiss": "Nothing happens to the message or its author. The report is closed as dismissed.",
    "remove_message": "The message is removed for everyone. It keeps its place as “This message has been removed” and cannot be restored.",
    "mute_participant": "The author keeps reading this conversation but can no longer post in it.",
    "note": "Note for the record (optional)",
    "notePlaceholder": "Why you decided this…",
    "submit": "Confirm",
    "submitting": "Working…",
    "cancel": "Cancel"
  },
  "toasts": {
    "reviewed": "Report reviewed."
  },
  "queueCard": {
    "title": "Open reports",
    "empty": "Nothing waiting.",
    "count_one": "{{count}} report waiting",
    "count_other": "{{count}} reports waiting",
    "open": "Open moderation"
  }
}
